<template>
        <!-- :show-file-list="true"
        :multiple="multiple"
        accept=".xlsx,.xls,.csv"
        :action="url"
        :data="uploaderData"
        :on-success="success"
        :before-upload="beforeUpload"
        :auto-upload="autoUpload" -->
    <base-upload
        style="margin-left:80px;"
        ref="upload"
        v-bind="$attrs"
        :data="uploaderData"
    >
        <el-button size="small" type='primary'>{{buttonName}}</el-button>
    </base-upload>
</template>
<script>
export default {
  name: 'import-data-upload',
  props: {
    buttonName:{
      type: String,
      default: "选择文件",
    },
    uploaderData:Object
  },
  data(){
    return {
      
    }
  },
  computed: {

  },
  methods: {
    // success(resp){
    //   console.log("success");
    //   if(resp.data.code==0){
    //     this.$message({
    //       type:"success",
    //       message:"导入成功"
    //     })
    //     this.$emit("closeDialog");
    //   }else{
    //     this.$message(resp.data.msg);
    //   }
    // },
    // beforeUpload(){
    //   if(!this.uploaderData.id){
    //     this.$message("请先选择导入列表类别数据")
    //     return false;
    //   }
    // }
  }
}
</script>
<style lang="stylus" scoped>
</style>